<form [formGroup]="userForm!" class="w-full sm:min-w-[50rem] pr-[1rem] sm:pr-0">
  <div class="flex flex-col gap-2 w-full">

    <div class="flex flex-col w-full lg:flex-row justify-between lg:gap-6">
      <!--            NAME-->
      <div class="flex flex-col gap-1 w-full">
        <mat-label>{{"user-name" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never">
          <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
          <input matInput pattern="[a-zA-Zа-яА-ЯѓЃќЌјЈџЏѕЅжЖљЈчЧњЌЌѝЍ ]*" type="text" [formControlName]="'name'"
            minlength="3" placeholder='{{"Name of user" | translate}}'>
          <mat-error *ngIf="userForm.get('name')! && userForm.get('name')?.errors">
            <span *ngIf="userForm.get('name')?.hasError('required')!">{{"Required Field" | translate}}</span>
            <span *ngIf="userForm.get('name')?.hasError('minlength')!">{{"Required minimum 3 caracters" | translate}}</span>
            <span *ngIf="userForm.get('name')?.hasError('pattern')!">{{"Allowed only letters" | translate}}</span>
          </mat-error>
        </mat-form-field>
      </div>

      <!--            SURNAME-->
      <div class="flex flex-col gap-1 w-full">
        <mat-label>{{"user-surname" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never">
          <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
          <input matInput pattern="[a-zA-Zа-яА-ЯѓЃќЌјЈџЏѕЅжЖљЈчЧњЌЌѝЍ ]*" type="text"
            [formControlName]="'surname'" minlength="3" placeholder='{{"Surname of user" | translate}}'>
          <mat-error *ngIf="userForm.get('surname')! && userForm.get('surname')?.errors">
            <span *ngIf="userForm.get('surname')?.hasError('required')!">{{"Required Field" | translate}}</span>
            <span *ngIf="userForm.get('surname')?.hasError('minlength')!">{{"Required minimum 3 caracters" |
              translate}}</span>
            <span *ngIf="userForm.get('surname')?.hasError('pattern')!">{{"Allowed only letters" |
              translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>
    </div>

    <div class="flex flex-col w-full lg:flex-row justify-between lg:gap-6">
      <!--            EMAIL-->
      <div class="flex flex-col gap-1 w-full ">
        <mat-label>{{"user-email" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never">
          <mat-icon matPrefix><i class="fa-regular fa-envelope text-[2rem] pr-[1rem]"></i></mat-icon>
          <input matInput type="text" [formControlName]="'email'" placeholder='{{"Email of user" | translate}}'>
          <mat-error *ngIf="userForm.get('email')! && userForm.get('email')?.errors">
            <span *ngIf="userForm.get('email')?.hasError('required')!">{{"Required Field" | translate}}</span>
            <span *ngIf="userForm.get('email')?.hasError('pattern')!">{{"Email invalid" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

      <!--            PHONE NUMBER-->
      <div class="flex flex-col gap-1 w-full ">
        <mat-label>{{"user-phone" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never">
          <mat-icon matPrefix><i class="fa-regular fa-phone text-[2rem] pr-[1rem]"></i></mat-icon>
          <input matInput type="numeric" [formControlName]="'phone'" minlength="6"
            placeholder='{{"Phone of user" | translate}}' required>
          <mat-error *ngIf="userForm.get('phone')! && userForm.get('phone')?.errors">
            <span *ngIf="userForm.get('phone')?.hasError('required')!">{{"Required Field" | translate}}</span>
            <span *ngIf="userForm.get('phone')?.hasError('minlength')!">{{"Required minimum 3 caracters" | translate}}</span>
            <span *ngIf="userForm.get('phone')?.hasError('pattern')!">{{"Phone invalid" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>
    </div>

    <div class="flex flex-col w-full lg:flex-row justify-between lg:gap-6">
      <div class="flex flex-col gap-1 w-full ">
      <!--USERNAME-->
      <mat-label>{{"username" | translate}}</mat-label>
      <mat-form-field appearance="outline" floatLabel="never">
        <mat-icon matPrefix><i class="fa-regular fa-user text-[2rem] pr-[1rem]"></i></mat-icon>
        <input matInput type="numeric" [formControlName]="'username'" minlength="6"
          placeholder='{{"username" | translate}}'>
        <mat-error *ngIf="userForm.get('phone')! && userForm.get('phone')?.errors">
          <span *ngIf="userForm.get('username')?.hasError('required')!">{{"Required Field" | translate}}</span>
          <span *ngIf="userForm.get('username')?.hasError('minlength')!">{{"Required minimum 3 caracters" |
            translate}}</span>
          <span *ngIf="userForm.get('username')?.hasError('pattern')!">{{"Allowed only letters" |
            translate}}</span>
        </mat-error>
      </mat-form-field>
      </div>

      <!--            ROLE TYPE-->
      <div class="flex flex-col gap-1 w-full "
        *ngIf="this.userId==undefined || (this.userId !== undefined && userProfileData !== undefined && userProfileData.roleId !== undefined && userProfileData.roleId !== 2)">
        <mat-label>{{"user-role" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="never">
          <mat-icon matPrefix>
            <i class="fa-regular fa-list"></i>
          </mat-icon>
          <mat-select [formControlName]="'role'" (selectionChange)="onRoleChanged($event)"
            placeholder='{{"user-role" | translate}}' required>
            <mat-option [value]="0" disabled>{{"Select a user role" | translate }}</mat-option>
            <mat-option *ngFor="let role of roles" [hidden]="true" [value]="role.id">
              {{ role.name }}
            </mat-option>

          </mat-select>
          <mat-error *ngIf="userForm.get('role')! && userForm.get('role')?.errors">
            <span *ngIf="userForm.get('role')?.hasError('required')">{{"Required Field" | translate}}</span>
          </mat-error>
          <mat-error> <span *ngIf="userForm.get('role')?.hasError('min')">{{"Required Field" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

    </div>

    <!--            SERVICE CATEGORIES-->
    <div *ngIf="showServiceCategories">
      <div class="mb-2">{{"Select categories of services offered by the employee" | translate }}</div>
      <div
        class="flex flex-col w-full lg:flex-row gap-5 py-4 border border-r-transparent border-l-transparent border-bottom-[#2C99B1] border-top-[#2c99b1]">
        <div *ngFor="let category of serviceCategories">
          <div class="py-1 px-3 border border-[#2C99B1] text-black-100 rounded-md hover:cursor-pointer"
            [ngClass]="{'bg-[#2C99B1] text-white flex flex-row gap-3 items-center': isCategoryChosen(category.id!)}"
            (click)="selectServiceCategory(category.id! )">
            <div>{{category.name}}</div>
            <i *ngIf="isCategoryChosen(category.id!)" class="fa-regular fa-check text-white"></i>
          </div>
        </div>
      </div>
    </div>

    <!--            ACTIVE-->
    <div
      class="flex flex-row gap-5 justify-between items-center w-full py-2 border border-r-transparent border-l-transparent border-t-transparent border-bottom-[#2C99B1] mb-[2rem]">
      <div>{{'status' | translate}}:</div>
      <mat-checkbox class="-mb-1 font-semibold text-end" [formControlName]="'active'">
        <div class="pl-[0.5rem] mt-[-.5rem]">
          <div class="opacity-0 h-0" [ngClass]="{'opacity-100 h-auto' : userForm.get('active')?.value === true }"> {{'user-active' | translate}} </div>
          <div class="opacity-0 h-0" [ngClass]="{'opacity-100 h-auto': userForm.get('active')?.value === false}"> {{'user-inactive' | translate}} </div>
        </div>
    </mat-checkbox>
    </div>

  </div>

  <!--        ERROR-->
  <div *ngIf="showError"
    class="w-full py-3 px-5 flex flex-row gap-3 bg-[#F5D3D3] text-[#D94E4E] rounded-lg items-center my-[1rem]">
    <i class="fa-sharp fa-regular fa-triangle-exclamation text-3xl"></i>
    <div>{{"username already exist" | translate }}</div>
  </div>

  <!--        ACTION BUTTONS-->
  <div class="flex flex-row gap-10 text-[1rem] lg:text-[1.35rem]">
    <button (click)="closePopup()" type="button"
      class="w-1/2 px-5 py-[.5rem] uppercase rounded-[.25rem] bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
      {{"back" | translate}}
    </button>

    <button [disabled]="userForm.invalid" [ngClass]="{
          'bg-[#b98d78] hover:bg-[#a57d6a] ': userForm.valid,
          'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': userForm.invalid
        }" (click)="submit()" type="submit"
      class="w-1/2 px-5 py-[.5rem] uppercase rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
      {{"save" | translate}}
    </button>
  </div>
</form>